import React, { useState } from "react";

import { Layout, MetaTag } from "src/components";
import { BookForm } from "../../../components";
import { Card, Col, Row, Spin } from "antd";

const EditView = (props: any) => {
    const { book, onFinish, onFinishFailed } = props;

    return (
        <Layout
            titles={[
                { name: "Books", link: "/book" },
                { name: "Edit", link: "" },
                { name: book?.name, link: "" },
            ]}
        >
            <MetaTag title="Add Book" />
            <Row justify="center" align="middle">
                <Col xs={12} lg={20} md={24}>
                    <Card
                        style={{ borderRadius: "8px", padding: "12px" }}
                        title={"Book Update"}
                        bordered={true}
                    >
                        {book && (
                            <BookForm
                                book={book}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                            />
                        )}
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default EditView;
